import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CuratedForYouHero from "./sections/CuratedForYouHero";
import CoastalFoundationsCollections from "./sections/CoastalFoundationsCollections";
import DestaquesDaSemana from "./sections/DestaquesDaSemana";
import ConsultingWorkflow from "./sections/ConsultingWorkflow";
import WhatOurCommunitySays from "./sections/WhatOurCommunitySays";
import StrategicUpdates from "./sections/StrategicUpdates";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CuratedForYouHero />
      <CoastalFoundationsCollections />
      <DestaquesDaSemana />
      <ConsultingWorkflow />
      <WhatOurCommunitySays />
      <StrategicUpdates />
      <Footer />
    </div>;
}